export default __webpack_public_path__ + "static/media/uploading.946d3f38.gif";